var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-sidebar",
    {
      attrs: {
        type: "is-white",
        overlay: _vm.overlay,
        fullheight: _vm.fullheight,
        fullwidth: _vm.fullwidth,
        "can-cancel": false,
        right: _vm.right,
      },
      on: { close: _vm.close },
      model: {
        value: _vm.showSidebar,
        callback: function ($$v) {
          _vm.showSidebar = $$v
        },
        expression: "showSidebar",
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "file-previewer-container",
          class: { "no-fullwidth": !_vm.fullwidth },
        },
        [
          _c(
            "div",
            { staticClass: "row-container has-background-primary-dark" },
            [
              _c("div", { staticClass: "first-row py-3 px-5" }, [
                _c("div", { staticClass: "is-pulled-right ml-2 mb-2" }, [
                  _c(
                    "a",
                    { staticClass: "has-text-white", on: { click: _vm.close } },
                    [_c("i", { staticClass: "fas fa-times fa-lg" })]
                  ),
                ]),
                _vm._v(" "),
                _c("h3", { staticClass: "subtitle is-7 has-text-white" }, [
                  _vm._v("Previsualizar archivo"),
                ]),
                _vm._v(" "),
                _vm.previewedFile
                  ? _c("h3", { staticClass: "title is-6 has-text-white" }, [
                      _vm._v(_vm._s(_vm.previewedFile.nombre)),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _vm.loadingFile
                ? _c("div", { staticClass: "second-row has-text-centered" }, [
                    _c("i", {
                      staticClass:
                        "fas fa-sync fa-lg fa-spin mt-6 has-text-primary",
                    }),
                  ])
                : _c("iframe", {
                    staticClass: "second-row",
                    attrs: { src: _vm.fileUrl, frameborder: "0" },
                  }),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }